import React, { } from 'react'
import { DeleteOutlined, EditOutlined, Loading3QuartersOutlined, SearchOutlined, EyeOutlined, SwapRightOutlined, PlusOutlined, BarChartOutlined, CopyOutlined } from '@ant-design/icons'
import { Button, Input, message, Modal, Radio, Tag } from 'antd'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import MainTable from '../../components/Basic/MainTable'
import useParams from '../../hook/useParams'
import { MenuWrapper, SearchWrapper, WhiteWrapper } from './invoice.styled'
import { delInvoice, delInvoiceSegment, fetchInvoice, fetchInvoiceSegment } from '../../apis/invoice'

function Invoice (props) {
  const { audienceMode } = props
  const { t: ln_t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { pathname } = location || {}
  const user = useSelector((state) => state.user)
  const { nowGroup, nowBrand } = user || {}
  // const adminMode = Boolean(groups?.find(i => i.id === nowGroup)?.groupType)
  const params = useParams({ groupId: nowGroup, brandId: nowBrand })
  const { handleFetchParams, fetchParams } = params
  const delApi = audienceMode ? delInvoiceSegment : delInvoice
  // const [downloadLoading, setDownloadLoading] = useState()

  // const onDownload = (src, name) => {
  //   const url = src
  //   const link = document.createElement('a')
  //   link.href = url
  //   link.download = name
  //   document.body.appendChild(link)
  //   link.click()
  //   URL.revokeObjectURL(url)
  //   link.remove()
  // }
  // const handleDownload = async (id, data) => {
  //   setDownloadLoading(id)
  //   const res = await downloadInvoice(id)
  //   if (res?.status === 200) {
  //     const src = window.URL.createObjectURL(new Blob([res?.data]))
  //     const name = `${data?.name}.csv`
  //     onDownload(src, name)
  //   }
  //   setDownloadLoading()
  // }
  const handleDelete = async (id, data) => {
    Modal.confirm({
      title: `${ln_t('util.delete')} ${data.name}`,
      content: `${ln_t('message.confirm.delete')} ${data.name}?`,
      onOk: async () => {
        const result = await delApi(id)
        if (result?.status === 204) {
          handleFetchParams('add', {})
          message.success(ln_t('message.success.delete'))
        }
      }
    })
  }

  const apiFunc = async () => audienceMode ? fetchInvoiceSegment(fetchParams) : fetchInvoice(fetchParams)
  const previewStatus = {
    ready: { title: ln_t('segment.ready'), color: 'gold' },
    doing: { title: ln_t('segment.doing'), color: 'geekblue', icon: <Loading3QuartersOutlined spin /> },
    done: { title: ln_t('segment.done'), color: 'green' },
    error: { title: ln_t('segment.error'), color: 'red' },
    'api error': { title: ln_t('segment.apiError'), color: 'red' }
  }
  const formatDate = (date, detail) => date ? dayjs(date).format(detail ? 'DD-MM-YYYY HH:mm:ss' : 'DD-MM-YYYY') : '-'
  const columns = [
    { title: ln_t('invoice.name'), dataIndex: 'name', sorter: true },
    {
      title: ln_t('invoice.timeInterval'),
      dataIndex: 'id',
      width: 160,
      render: (e, data) => data?.startDate || data?.endDate
        ? <span>{formatDate(data?.startDate)} <SwapRightOutlined style={{ fontSize: '12px', margin: '0 6px' }} /> {formatDate(data?.endDate)}</span>
        : '-'
    },
    ...audienceMode ? [{ title: ln_t('invoice.count'), dataIndex: 'count', render: e => e?.toLocaleString() }] : [],
    {
      title: ln_t('invoice.status'),
      dataIndex: 'status',
      render: e => {
        const { title, icon, color, component } = previewStatus[e] || {}
        return component || <Tag style={{ width: '80px', cursor: 'default', textAlign: 'center' }} color={color} icon={icon}>{title}</Tag>
      }
    },
    { title: ln_t('util.createdAt'), dataIndex: 'createdAt', render: e => formatDate(e), sorter: true },
    !audienceMode && { title: ln_t('util.updatedAt'), dataIndex: 'updatedAt', render: e => formatDate(e), sorter: true },
    {
      title: ln_t('util.action'),
      dataIndex: 'id',
      render: (id, data) => audienceMode
        ? <div className="action-btn">
          <Button size='small' disabled={data?.status !== 'done'} onClick={() => navigate('/targeting/new', { state: { data, goBackPath: pathname, fromInvoice: true } })}>{ln_t('invoice.audienceDelivery')}</Button>
          <Button size='small' disabled={data?.status !== 'done'} onClick={() => navigate('/segment/new', { state: { data, goBackPath: pathname, fromInvoice: true } })}>{ln_t('invoice.audienceMapping')}</Button>
          <Button size="small" icon={<EditOutlined />} onClick={() => navigate(`${pathname}/edit`, { state: { data } })} />
          <Button size="small" icon={<DeleteOutlined />} onClick={() => handleDelete(id, data)} />
        </div>
        : <div className="action-btn">
          <Button size="small" icon={<EyeOutlined />} onClick={() => navigate(`${pathname}/viewSetting`, { state: { data } })} />
          <Button size="small" icon={<BarChartOutlined />} disabled={data?.status !== 'done'} onClick={() => navigate(`${pathname}/preview`, { state: { data } })} />
          <Button size="small" icon={<DeleteOutlined />} onClick={() => handleDelete(id, data)} />
          {/* {adminMode && <Button
            size="small"
            icon={<DownloadOutlined />}
            disabled={data?.status !== 'done' || !data?.saveAsFile}
            onClick={() => handleDownload(id, data)}
            loading={downloadLoading === id}
          />} */}
          <Button size="small" icon={<CopyOutlined />} onClick={() => navigate(`${pathname}/new`, { state: { data } })} />
        </div>
    }
  ]

  const menu = [
    { value: 'invoice', label: ln_t('dashboard.dashboard') },
    { value: 'audience', label: ln_t('invoice.invoiceAudience') }
  ]
  return <div>
    <MenuWrapper>
      <Radio.Group
        buttonStyle="solid"
        value={pathname?.includes('/audience') ? 'audience' : 'invoice'}
        onChange={e => navigate(e?.target?.value === 'audience' ? `${pathname}/audience` : '/consumerInsights')}
        options={menu}
        optionType="button"
      />
    </MenuWrapper>
    <WhiteWrapper>
      <h3>{audienceMode ? ln_t('invoice.invoiceAudience') : ln_t('dashboard.dashboard')}</h3>
      <SearchWrapper>
        <Input.Search
          allowClear
          style={{ width: '400px' }}
          placeholder={ln_t('util.search')}
          onSearch={e => handleFetchParams('add', { name_like: e ? `%${e}%` : undefined })}
          enterButton={<Button type="primary" size="small" icon={<SearchOutlined />} />}
        />
        <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate(`${pathname}/new`)}>
          {ln_t('util.add')} {audienceMode ? ln_t('invoice.invoiceAudience') : ln_t('invoice.chart')}
        </Button>
      </SearchWrapper>

      <MainTable
        columns={columns}
        rowKey="id"
        apiFunc={apiFunc}
        params={params}
        disabledRow={record => !record.previewCount || !record.status}
      />
    </WhiteWrapper>
  </div>
}

export default Invoice
